import "./LoginGoogle.scss";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { doGoogleLogin } from "../../../redux/actions/user";
import { useGoogleLogin } from "@react-oauth/google";
import { Navigate, useNavigate } from "react-router-dom";
import ls from "../../../services/localStorage";
import validateToken from "../../../services/validateToken";
import Icon from "../../../components/Icon/Icon"


function LoginGoogle() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [token, setToken] = useState(ls.get("token"));

  const onSuccess = async (tokenResponse) => {
    dispatch(doGoogleLogin(tokenResponse.access_token)).then(async ()=>{
      const newToken = await ls.get('token');
      setToken(newToken);
      // Redirigir al returnURL guardado o a home
      const returnUrl = ls.get("LOGIN_RETURN_URL");
      if (returnUrl) {
        ls.remove("LOGIN_RETURN_URL");
        navigate(returnUrl);
      } else {
        navigate("/");
      }
    })
  };

  const onError = () => {
    console.log("Login Failed");
  };

  const login = useGoogleLogin({
    onSuccess: onSuccess,
    onError: onError,
  });

  return validateToken.validate(token) ? (
    <Navigate to="/" replace={true} />
  ) : (
    <button className="button" onClick={login}>
      <Icon
        name="google"
        size="medium"
        color="secondary-1"
      ></Icon>
      Continúa con Google
    </button>
  );
}

export default LoginGoogle;
